import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { SpartanHelmet } from '@/components/icons/spartan-helmet'
import { AnimatedGrid } from './animated-grid'
import { Zap, CreditCard, Headphones } from 'lucide-react'

export function HeroSection() {
  const { t } = useTranslation('landing')

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden px-4 py-20">
      <AnimatedGrid />

      <div className="relative z-10 max-w-5xl mx-auto text-center space-y-8">
        {/* Logo + Title */}
        <div className="space-y-6 animate-slide-in-bottom">
          <div className="flex justify-center">
            <div className="relative">
              <div className="w-28 h-28 rounded-full bg-indigo-500/10 flex items-center justify-center animate-pulse-glow">
                <SpartanHelmet className="w-16 h-16 text-indigo-400" />
              </div>
              <div className="absolute inset-[-8px] rounded-full border-2 border-indigo-500/30 animate-spin-slow" />
            </div>
          </div>

          <h1 className="text-5xl md:text-7xl font-bold tracking-tight">
            <span className="text-gradient-primary">ARCHON</span>
          </h1>

          <h2 className="text-3xl md:text-5xl font-bold text-white max-w-4xl mx-auto leading-tight">
            {t('hero.title')}
          </h2>

          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed">
            {t('hero.subtitle')}
          </p>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-scale-in">
          <Button size="lg" className="w-full sm:w-auto glow-primary" asChild>
            <Link to="/login">{t('hero.ctaPrimary')}</Link>
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto" asChild>
            <Link to="/login">{t('hero.ctaSecondary')}</Link>
          </Button>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-6 pt-8 text-sm text-gray-500 animate-fade-in">
          <div className="flex items-center gap-2">
            <Zap className="w-4 h-4" />
            <span>{t('hero.trustSetup')}</span>
          </div>
          <div className="flex items-center gap-2">
            <CreditCard className="w-4 h-4" />
            <span>{t('hero.trustCard')}</span>
          </div>
          <div className="flex items-center gap-2">
            <Headphones className="w-4 h-4" />
            <span>{t('hero.trustSupport')}</span>
          </div>
        </div>
      </div>
    </section>
  )
}
